import { Stack, useDisclosure } from "@chakra-ui/react";
import { TemplateCard } from "@pufflig/prompt-studio-ui";
import { useState } from "react";
import { CreatePromptbookModal } from "./CreatePromptbookModal";

export const PromptbookTemplateList = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedTemplateId, setSelectedTemplateId] = useState<string | null>(null);
  const canEdit = true;

  return (
    <>
      <Stack direction="row" gap="spacing-lg" overflow="auto" paddingBottom="1rem">
        <TemplateCard
          isBlank
          isDisabled={!canEdit}
          title="Start from scratch"
          description="Create a new Promptbook from scratch."
          onClick={() => {
            setSelectedTemplateId(null);
            onOpen();
          }}
        />
      </Stack>
      <CreatePromptbookModal isOpen={isOpen} onClose={onClose} selectedTemplateId={selectedTemplateId} />
    </>
  );
};
